import React from 'react';

import type { OutcomeNode as IOutcomeNode, WorkflowNodeProps } from 'flow/service/graph';
import ConstructionNode from '../ConstructionNode';


/**
 * Outcome nodes are not rendered on canvas, they are instead rendered in the OutcomeIsland.
 * This is due the fact that we need to keep them fixed as the user pans around and re-adjusting
 * the layout every time the user moves takes a lot of resources and is not quite possible.
 *
 * To keep the code consistent and easy to read, we do have this OutcomeNode component that instead
 * renders the ConstructionNode instead.
 *
 * As mentioned in multiple places throughout the codebase, we need construction nodes for outcomes
 * to enable connections between canvas nodes and OutcomeIsland nodes - these outcome construction
 * nodes are positioned under the outcome island to simulate this effect
 */
function OutcomeNode(props: WorkflowNodeProps<IOutcomeNode>) {
  return <ConstructionNode {...props} />;
}

export default React.memo(OutcomeNode);
